<template>
  <b-overlay
    :show="showLoader || showLoaderUploaded"
    opacity="0.50"
    rounded="sm"
  >
    <b-card class="mb-0 business-card">
      <b-card-header><b-card-title> Seleccione un plan de estudios para cargar los documentos</b-card-title></b-card-header>
      <selectespecialidades
        class="py-2"
        :esp.sync="Especialidadn"
        :mat.sync="inmatricula"
        @tipoEsp="Especialidadn=$event"
      />
      <p><small>* Solo se muestran los posgrados a las que el alumno está inscrito y activo.</small></p>

      <b-tabs
        v-if="Especialidadn"
        pills
        align="center"
      >
        <b-tab
          title="Archivos cargados"
          active
        >
          <div>
            <!-- Título de archivos guardados -->
            <b-card-title class="mb-1">
              Archivos guardados {{ (inmatricula !== 0) ? 'de la matricula: '+inmatricula : '' }}
            </b-card-title>

            <!-- Mensaje de en caso de no tener los documentos -->
            <b-alert
              variant="warning"
              :show="loadedFiles.length === 0"
            >
              <div class="alert-body text-center">
                <small>No tienes archivos por el momento.</small>
              </div>
            </b-alert>

            <document-list
              :data="loadedFiles"
              status-icon
            />
          </div>
        </b-tab>

        <b-tab
          title="Subir archivos"
        >
          <div>
            <!-- Título de documentación obligatoria -->
            <b-card-title class="mb-1">
              Documentación
            </b-card-title>
            <!-- Mensaje de documentos permitidos -->
            <b-alert
              variant="danger"
              show
            >
              <div class="alert-body text-center">
                <small>Recuerde subir solo los formatos permitidos <b>[ jpg, png, pdf ]</b>.</small>
              </div>
            </b-alert>

            <!-- Inputs -->
            <div v-if="showContent && !showError">
              <b-form-group>
                <label for="tipo-doc-id">
                  <b>Indique el tipo de archivo a subir</b>
                </label>

                <b-skeleton-wrapper :loading="showLoaderTypes">
                  <!-- Loader -->
                  <template #loading>
                    <b-skeleton
                      type="button"
                      width="100%"
                    />
                  </template>
                  <v-select
                    id="tipo-doc-id"
                    v-model="tipoSelected"
                    label="nombre"
                    placeholder="Seleccione el tipo de documento que subirá"
                    :options="tipoDocs"
                    :selectable="(option) => !loadedFiles.find(doc => doc.tipo === option.id)"
                  >
                    <template #option="{ id, nombre }">
                      <span>{{ nombre }} <b>{{ loadedFiles.find(doc => doc.tipo === id) ? '(Documento cargado)' : '' }}</b></span>
                    </template>
                  </v-select>
                </b-skeleton-wrapper>
              </b-form-group>

              <!-- Acta de nacimiento -->
              <b-form-group v-if="tipoSelected">
                <label for="acta-nacimiento-id">
                  <b>Seleccione documento</b>
                </label>
                <b-form-file
                  v-show="!fileLoader"
                  id="acta-nacimiento-id"
                  v-model="file"
                  accept=".jpg, .png, .pdf"
                  placeholder="No has seleccionado ningún archivo"
                  drop-placeholder="Agregar archivo"
                  browse-text="Buscar"
                  :state="Boolean(file)"
                />
                <b-progress
                  v-show="fileLoader"
                  animated
                  :value="100"
                  variant="success"
                  class="progress-bar-success mb-1"
                />
              </b-form-group>
            </div>

            <!-- Botones -->
            <div
              v-if="showContent && !showError && tipoSelected"
              class="mt-2"
            >
              <!-- Enviar documentos -->
              <b-button
                variant="primary"
                type="submit"
                block
                @click="uploadFiles()"
              >
                <feather-icon
                  icon="SendIcon"
                  class="mr-50"
                />
                <span class="align-middle">Subir documentos</span>
              </b-button>
            </div>

          </div>
        </b-tab>
        <b-tab title="Ayuda">
          <div class="mb-0 business-card">
            <h5 class="text-primary mb-75 mt-2">
              <b>Ayuda sobre documentación</b>
            </h5>
            <b-card-text class="mr-5 ml-1">
              <requisitos :plan="Especialidadn && Especialidadn.id ? Especialidadn.id : null" />

            </b-card-text>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BCard,
  BCardTitle,
  BFormFile,
  BAlert,
  BCardText,
  BOverlay,
  BTabs,
  BTab,
  BProgress,
  BSkeletonWrapper,
  BSkeleton,
  BCardHeader,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  onMounted,
  ref,
  computed,
  watch,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import { formhttp } from '@core/utils/utils'
import documentList from '@/views/components/documentacion/documentList.vue'
import { getDocumentTypesForPlan, uploadedDocuments, assignAsPersonalDocument } from '@/views/components/documentacion/useDocumentacion'
import requisitos from '@/views/public/oferta-academica/components/detalle-oferta/tabs/requisitos.vue'

import selectespecialidades from '@/views/components/selects/select-especialidad-activa.vue'

export default {
  components: {
    BButton,
    BFormGroup,
    BCard,
    BCardTitle,
    BCardText,
    BFormFile,
    BAlert,
    BOverlay,
    BTabs,
    BTab,
    BProgress,
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
    requisitos,
    documentList,
    BCardHeader,
    selectespecialidades,
  },
  props: {
    inpersonafk: {
      type: [String, Number],
      default: () => 0,
    },
    inmatricula: {
      type: Number,
      default: () => 0,
    },
    actualizardocs: {
      type: Boolean,
      default: () => false,
    },
  },

  setup(props, { emit }) {
    const toast = useToast()
    const personaId = ref(null)
    const showContent = ref(false)
    const showError = ref(false)
    const showLoader = ref(false)
    const showLoaderUploaded = ref(false)
    const showLoaderTypes = ref(false)
    const fileLoader = ref(false)
    const file = ref(null)
    const loadedFiles = ref([])
    const tipoSelected = ref(null)
    const tipoDocs = ref([])
    const Especialidadn = ref(null)
    const uploadConfig = computed(() => {
      const dataReturn = {
        ref: tipoSelected.value.subPath,
        cat: 9,
        repo: 0,
        struct: 3,
      }
      return dataReturn
    })

    const loadDocTypes = () => {
      if (!Especialidadn.value) return
      getDocumentTypesForPlan(Especialidadn.value.id)
        .then(response => {
          showLoaderTypes.value = false
          if (response.status !== 200) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Información de tipo de documentos',
                text: response.message,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
          }
          tipoDocs.value = response.data || []
        }, error => {
          showLoaderTypes.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // * Get uploaded files
    const loadUploaded = () => {
      showLoaderUploaded.value = true
      const plan = Especialidadn.value && Especialidadn.value.id ? Especialidadn.value.id : null
      const params = { action: 1, token: store.state.cuenta.session.token, plan }
      if (props.inpersonafk !== 0 && props.inmatricula !== 0) params.cp = personaId.value

      uploadedDocuments(params, 'wsdocumentos')
        .then(response => {
          showLoaderUploaded.value = false
          showContent.value = true
          if (response.status !== 200) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Información de documentos',
                text: response.message,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
          }
          loadedFiles.value = response.data || []
          emit('documentosCargados', loadedFiles.value)
        }, error => {
          showLoaderUploaded.value = false
          showContent.value = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    //* On mounted fetch user's data
    onMounted(() => {
      personaId.value = store.state.cuenta.session.cp
      if (props.inpersonafk !== 0 && props.inmatricula !== 0) personaId.value = props.inpersonafk
    })

    //* Upload files
    const uploadFiles = () => {
      const plan = Especialidadn.value && Especialidadn.value.id ? Especialidadn.value.id : null

      if (file.value && tipoSelected.value && tipoSelected.value.id) {
        fileLoader.value = true
        // uploadConfig.value.file = file.value

        assignAsPersonalDocument({
          task: 'wsdocumentos', action: 4, token: store.state.cuenta.session.token, p: personaId.value, f: JSON.stringify(uploadConfig.value), td: tipoSelected.value.id, fi: file.value,
        }).then(response => {
          if (response.data.message.msg === 'OK') {
            const [dlvryResponse] = response.data.message.ids
            assignAsPersonalDocument({
              task: 'wsdocumentos', action: 2, token: store.state.cuenta.session.token, cp: personaId.value, f: dlvryResponse.id, td: tipoSelected.value.id, plan,
            })
              .then(result => {
                fileLoader.value = false
                const { icon, label } = formhttp(result.status)

                if (result.status === 200) {
                  file.value = null
                  loadUploaded()
                }

                toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Resultado de asignación',
                    text: result.message,
                    icon,
                    variant: label,
                  },
                },
                { timeout: 10000 })
              }, error => {
                fileLoader.value = false
                toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error al asignar documento',
                    text: error,
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                  },
                },
                { timeout: 10000 })
              })
          } else {
            fileLoader.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Intento de guardado',
                text: response.data.msg,
                icon: response.icon,
                variant: response.label,
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          fileLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al subir el documento al servidor',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Envío de documentos',
            text: 'Asegúrese de cargar como mínimo un archivo',
            icon: 'FileIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      }
    }

    watch(() => Especialidadn.value, () => {
      emit('documentosCargados', [])
      loadDocTypes()
      loadUploaded()
    })
    watch(() => props.actualizardocs, () => {
      if (props.actualizardocs) {
        emit('documentosCargados', [])
        emit('actualizardocs', false)
        loadDocTypes()
        loadUploaded()
      }
    })

    return {
      file,
      loadedFiles,
      tipoDocs,
      tipoSelected,
      Especialidadn,
      // Flags
      fileLoader,
      showLoader,
      showLoaderUploaded,
      showLoaderTypes,
      showContent,
      showError,

      // Methods
      uploadFiles,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
